let utils = require('../../utils')
import ShopOrderDetailRecord from '../ShopOrderDetailRecord'
import constant from 'src/store/constant'
export default {
  name: 'shop-order-detail',
  async created () {
    // 期間チェック
    const res = await this.$store.dispatch('STOCK_CHECK_PERIOD')
    if (!res.data) {
      this.$router.push('/stock')
    }
    this.getShopOrder()
    this.getShopOrderDetails()
    this.getShopOrderHoldOnPlaces()
    this.getShopOrderSuppliers()
    this.zeroInfinityConstant = constant.zeroInfinity
  },
  data () {
    return {
      shopOrder: {},
      shopOrderDetails: [],
      shopOrderSuppliers: [],
      queryConsumableItemName: '',
      querySupplierName: '',
      queryHoldOnPlaceName: '',
      shopOrderHoldOnPlaces: [],
      getShopOrderFlug: false,
      getShopOrderDetailsFlug: false,
      zeroInfinityConstant: {}
    }
  },
  computed: {
    formatedTotalPrice () {
      let totalPrice = 0
      this.shopOrderDetails.map(shopOrder => {
        totalPrice += shopOrder.order_lot_quantity * shopOrder.lot_price
      })
      if (this.isZeroInfinitySendCost) {
        totalPrice += this.zeroInfinityConstant.sendPrice
      }
      return totalPrice.toLocaleString()
    },
    isDisabledReject () {
      return this.shopOrder.status === 'before_stock_check' ||
              this.shopOrder.status === 'before_manager_confirm' ||
              this.shopOrder.status === 'head_office_reject' ||
              this.shopOrder.status === 'order_completed'
    },
    isZeroInfinitySendCost () {
      // ゼロインフィニティの消耗品が存在するか
      const isAllNoFee =
            this.shopOrderDetails.every(shopOrderDetail =>
              shopOrderDetail.fee_type === 'no_fee'
            )
      if (isAllNoFee) return false
      // 合計金額チェック
      let zeroInfinityTotalPrice = 0
      this.shopOrderDetails.map((shopOrderDetail) => {
        if (shopOrderDetail.fee_type === 'zero_infinity') {
          zeroInfinityTotalPrice +=
            shopOrderDetail.lot_price * shopOrderDetail.order_lot_quantity
        }
      })
      return zeroInfinityTotalPrice !== 0 && zeroInfinityTotalPrice < constant.zeroInfinity.boundaryPrice
    }
  },
  components: {
    ShopOrderDetailRecord
  },
  methods: {
    async getShopOrder () {
      const data = {
        id: this.$route.params.shop_order_id
      }
      let res = await this.$store.dispatch('SHOP_ORDER_GET', data)
                                  .catch(err => {
                                    console.log(err)
                                    return
                                  })
      this.shopOrder = utils.kebabSnakeConversion(res.data.data.attributes)
      this.getShopOrderFlug = true
    },
    async getShopOrderDetails () {
      this.shopOrderDetails = []
      const data = {
        shop_order_id: this.$route.params.shop_order_id,
        query_consumable_item_name: this.queryConsumableItemName,
        query_supplier_name: this.querySupplierName,
        query_hold_on_place_name: this.queryHoldOnPlaceName

      }
      const res = await this.$store.dispatch('SHOP_ORDER_DETAIL_GET', data)
                                  .catch(err => {
                                    console.log(err)
                                    return
                                  })
      res.data.data.map(orderDetail => {
        let converedOrderDetail = {}
        converedOrderDetail = utils.kebabSnakeConversion(orderDetail.attributes)
        converedOrderDetail.id = orderDetail.id
        this.shopOrderDetails.push(converedOrderDetail)
      })
      this.getShopOrderDetailsFlug = true
    },
    async getShopOrderHoldOnPlaces () {
      const data = {
        shop_order_id: this.$route.params.shop_order_id
      }
      const res = await this.$store.dispatch('SHOP_ORDER_HOLD_ON_PLACES', data)
                                  .catch(err => {
                                    console.log(err)
                                    return
                                  })
      if (Array.isArray(res.data)) {
        this.shopOrderHoldOnPlaces = res.data
      }
    },
    async getShopOrderSuppliers () {
      const data = {
        shop_order_id: this.$route.params.shop_order_id
      }
      const res = await this.$store.dispatch('SHOP_ORDER_SUPPLIERS', data)
                                  .catch(err => {
                                    console.log(err)
                                    return
                                  })

      this.shopOrderSuppliers = res.data
    },
    async setOrderLotQuantity (quantity, index) {
      this.shopOrderDetails[index].order_lot_quantity = quantity
    },
    async updateOrderLotQuantity (index) {
      const data = {
        id: this.shopOrderDetails[index].id,
        order_lot_quantity: this.shopOrderDetails[index].order_lot_quantity,
        is_head_office_change: true
      }
      await this.$store.dispatch('SHOP_ORDER_DETAIL_UPDATE', data)
                        .catch(err => {
                          console.log(err)
                          return
                        })
    },
    setStockQuantity (quantity, index) {
      this.shopOrderDetails[index].stock_quantity = quantity
    },
    async updateStockQuantity (index) {
      const data = {
        id: this.shopOrderDetails[index].id,
        stock_quantity: this.shopOrderDetails[index].stock_quantity
      }
      await this.$store.dispatch('SHOP_ORDER_DETAIL_UPDATE', data)
                        .catch(err => {
                          console.log(err)
                          return
                        })
    },
    async updateShopOrder (updateStauts) {
      let data = {
        id: this.$route.params.shop_order_id,
        status: updateStauts
      }
      if (updateStauts === 'head_office_confirmed') {
        data.head_office_confirm_date = new Date()
      }
      if (updateStauts === 'head_office_reject') {
        data.order_confirm_head_office_user_name = null
        data.head_office_confirm_date = null
      }
      await this.$store.dispatch('SHOP_ORDER_UPDATE', data)
                      .catch(err => {
                        console.log(err)
                        return
                      })
      this.$router.push('/shop_order_list')
    },
    isCanNotOrder () {
      for (let i = 0; i < this.shopOrderDetails.length; i++) {
        if (this.shopOrderDetails[i].is_can_order === 0) {
          return true
        }
      }
      return false
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/shop-order-detail.js